import { Injectable } from '@angular/core';
import { AccountType, Page, Role, Action, ResourceKey } from './permissions';
import { permissionMatrix, pagePermissionMatrix } from './permissionMatrix';

@Injectable({
    providedIn: 'root'
})

export class PermissionsService {

constructor() { }

  // Org-role hierarchy for member management (highest to lowest below Owner):
  // Administrator > Manager > Assistant > Resource. The numeric role values
  // don't match rank order, so rank is mapped explicitly.
  private readonly orgRoleRank: { [role: number]: number } = {
    0: 0, // Resource
    2: 1, // Assistant
    1: 2, // Manager
    3: 3  // Administrator
  };

  /**
   * Whether an actor may deactivate/activate a member below them — true only
   * when the actor's org role strictly outranks the target's. The Owner is
   * handled by the caller (Owner outranks everyone; is never a target here).
   */
  canManageMemberStatus(actorRole: number, targetRole: number): boolean {
    const actorRank = this.orgRoleRank[actorRole];
    const targetRank = this.orgRoleRank[targetRole];
    if (actorRank === undefined || targetRank === undefined) {
      return false;
    }
    return actorRank > targetRank;
  }

 hasPermission(
    accountType: AccountType,
    page: Page,
    resourceKey: ResourceKey,
    role: Role,
    action: Action
  ): boolean {
    const pageResources = permissionMatrix[accountType]?.[page];
    if (!pageResources) {
      return false;
    }
    const rolePerms = pageResources[resourceKey]?.[role] ?? [];
    return rolePerms.includes(action);
  }

  canViewPage(
    accountType: AccountType,
    page: Page,
    role: Role
  ): boolean {
    const allowedRoles = pagePermissionMatrix[accountType]?.[page] ?? [];
    return allowedRoles.includes(role);                                   
  }
}


